'use client';

import { useEffect } from 'react';
import { useA11yMode } from '@/hooks/useA11yMode';
import { applyPersistentLabels } from './a11yPersistentLabels';

/**
 * Mounted once in the root layout, inside the store provider. Keeps <html
 * data-a11y-mode> in step with the saved setting and, while the mode is on,
 * adds persistent visible labels to placeholder-only fields. Renders nothing.
 */
export function A11yModeRuntime() {
  const [mode] = useA11yMode();
  useEffect(() => {
    if (mode !== 'on') return;
    return applyPersistentLabels(document.body);
  }, [mode]);
  return null;
}
